import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const SaveButton = styled.a`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;

  &:focus {
    outline: -webkit-focus-ring-color auto 5px;
    outline-color: ${COLORS.primary};
  }
`;

export default SaveButton;
